import GoogleMapsLoader from 'google-maps'
GoogleMapsLoader.KEY = 'AIzaSyChPKV7wcFvkwi81W0dvqyoPYQaSFu72Lc'

let google = null
let geocoder = null
GoogleMapsLoader.load((instance) => {
  google = instance
  geocoder = new google.maps.Geocoder()
})

function init (el) {
  if (google) {
    const myLatlng = new google.maps.LatLng(48.858093, 2.294694)
    const mapOptions = {
      zoom: 12,
      center: myLatlng,
      scrollwheel: false // we disable de scroll over the map, it is a really annoing when you scroll through page
    }
    return new google.maps.Map(el, mapOptions)
  }
}

function geocode (address, success, error) {
  if (google && geocoder) {
    geocoder.geocode({'address': address}, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        if (success) success(results)
      } else {
        if (error) error('Geocode was not successful for the following reason: ' + status)
      }
    })
  }
}

function marker (options) {
  return google ? new google.maps.Marker(options) : null
}

export default {
  marker,
  init,
  geocode
}



// WEBPACK FOOTER //
// ./src/google-map.js